module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Arrival Plaza_RGB_lr.7946784b.jpg";